import { Col, Flex } from 'antd';
import { IoWalletOutline } from 'react-icons/io5';
import { Navigate } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import { Routes } from '@/routes';
import { Credit } from '@/components/common';
import themes from '@/context/AppContext/themes';
import { useDevice, useFaceEnrollmentModule, useThemeToken } from '@/hooks';
import { useAppContext, useUniversityContext } from '@/context';
import { useTranslation } from 'react-i18next';
import NavbarItem from './NavbarItem';
import { envConfig } from '@/configs';

const Navbar = () => {
  const theme = useThemeToken();
  const [t] = useTranslation(['common']);
  const { mode } = useAppContext();
  const { isDesktop } = useDevice();
  const { pathname } = useLocation();
  const { university } = useUniversityContext();

  const { visible } = useFaceEnrollmentModule();
  const modules = [];

  if (university?.samad?.nurture) {
    modules.push(
      <div className='relative'>
        <NavbarItem
          key="nurture"
          title={t('common:labels.nurture')}
          to={Routes.Food}
          activeTextColor="#43bf58"
          backColor={themes.nurture.token.colorPrimaryLight}
          inactiveTextColor={themes.nurture.token.colorTextOverPrimary}
          isActive={mode === 'nurture'}
        />
        {!isDesktop() && <hr className='absolute top-[38%] left-[-16px] w-full h-[2px] -z-10' style={{ backgroundColor: themes.nurture.token.colorPrimaryLight, display: mode === 'nurture' ? 'block' : 'none' }} />}
      </div>);
  }

  if (university?.samad?.transport) {
    modules.push(
      <div className='relative'>
        <NavbarItem
          key="transport"
          to={Routes.Transport}
          title={t('common:labels.transport')}
          activeTextColor="#333"
          backColor={themes.transport.token.colorPrimaryLight}
          inactiveTextColor={themes.transport.token.colorTextOverPrimary}
          isActive={mode === 'transport'}
        />
        {!isDesktop() && <hr className='absolute top-[38%] left-[-16px] w-full h-[2px] -z-10' style={{ backgroundColor: themes.nurture.token.colorPrimaryLight, display: mode === 'transport' ? 'block' : 'none' }} />}
      </div>
    );
  }

  if (university?.samad?.help_desk !== '') {
    modules.push(
      <div className='relative'>
        <NavbarItem
          key="helpdesk"
          to={Routes.Helpdesk}
          activeTextColor="#eaba31"
          title={t('common:nav.helpdesk')}
          backColor={themes.helpdesk.token.colorPrimaryLight}
          inactiveTextColor={themes.helpdesk.token.colorTextOverPrimary}
          isActive={mode === 'helpdesk'}
        />
        {!isDesktop() && <hr className='absolute top-[38%] left-[-16px] w-full h-[2px] -z-10' style={{ backgroundColor: themes.nurture.token.colorPrimaryLight, display: mode === 'helpdesk' ? 'block' : 'none' }} />}
      </div>
    );
  }

  if (university?.samad?.sport) {
    modules.push(
      <div className='relative'>
        <NavbarItem
          key="sport"
          to={Routes.Sport}
          title={t('common:labels.sport')}
          activeTextColor="#C53F3F"
          backColor={themes.sport.token.colorPrimaryLight}
          inactiveTextColor={themes.sport.token.colorTextOverPrimary}
          isActive={mode === 'sport'}
        />
        {!isDesktop() && <hr className='absolute top-[38%] left-[-16px] w-full h-[2px] -z-10' style={{ backgroundColor: themes.nurture.token.colorPrimaryLight, display: mode === 'sport' ? 'block' : 'none' }} />}
      </div>
    );
  }

  if (university?.samad?.Clinics) {
    modules.push(
      <div className='relative'>
        <NavbarItem
          key="health"
          to={Routes.Health}
          title={t('common:labels.health')}
          activeTextColor="#00cde2"
          backColor={themes.health.token.colorPrimaryLight}
          inactiveTextColor={themes.health.token.colorTextOverPrimary}
          isActive={mode === 'health'}
        />
        {!isDesktop() && <hr className='absolute top-[38%] left-[-16px] w-full h-[2px] -z-10' style={{ backgroundColor: themes.nurture.token.colorPrimaryLight, display: mode === 'health' ? 'block' : 'none' }} />}
      </div>
    );
  }

  if (university?.samad?.dormitory) {
    modules.push(<div className='relative'>
      <NavbarItem
        key="dormitory"
        to={Routes.Dormitory}
        title={t('common:labels.dormitory')}
        activeTextColor={themes.dormitory.token.colorPrimary}
        backColor={themes.dormitory.token.colorPrimaryLight}
        inactiveTextColor={themes.dormitory.token.colorTextOverPrimary}
        isActive={mode === 'dormitory'}
      />
      {!isDesktop() && <hr className='absolute top-[38%] left-[-16px] w-full h-[2px] -z-10' style={{ backgroundColor: themes.nurture.token.colorPrimaryLight, display: mode === 'dormitory' ? 'block' : 'none' }} />}
    </div>
    );
  }

  if (visible) {
    modules.push(
      <div className='relative'>
        <NavbarItem
          key="face"
          title={t('common:labels.shenas')}
          to={Routes.Face}
          activeTextColor={themes.face.token.colorPrimary}
          backColor={themes.face.token.colorPrimaryLight}
          inactiveTextColor={themes.face.token.colorTextOverPrimary}
          isActive={mode === 'face'}
        />
        {!isDesktop() && <hr className='absolute top-[38%] left-[-16px] w-full h-[2px] -z-10' style={{ backgroundColor: themes.nurture.token.colorPrimaryLight, display: mode === 'face' ? 'block' : 'none' }} />}
      </div>
    );
  }

  if (!!university?.samad?.Survey) {
    modules.push(<div className='relative'>
      <NavbarItem
        key="survey"
        title={t('common:labels.cultural')}
        to={Routes.Surveys}
        isActive={mode === 'survey'}
        activeTextColor={themes.survey.token.colorPrimary}
        backColor={themes.survey.token.colorPrimaryLight}
        inactiveTextColor={themes.survey.token.colorTextOverPrimary}
      />
      {!isDesktop() && <hr className='absolute top-[38%] left-[-16px] w-full h-[2px] -z-10' style={{ backgroundColor: themes.nurture.token.colorPrimaryLight, display: mode === 'survey' ? 'block' : 'none' }} />}
    </div>
    );
  }

  if ((modules.length === 0 && !pathname.startsWith('/no-module') && !pathname.includes('/loginCas'))) {
    return <Navigate to={Routes.ModuleInactive} />;
  }

  return (
    <Col span={5} md={3} lg={2} className="pt-4 lg:pt-0 home-body-nav-container"
      style={{
        backgroundColor: !isDesktop() ? '#fff' : theme.colorPrimaryLight,
      }}
    >
      <div className={`home-body-nav home-body-nav-${isDesktop() ? 'desktop' : 'mobile'}`}>
        <div className="home-body-nav-btn-container">
          {modules}
        </div>
        {!envConfig.ui.removeWallet &&
          <Link
            to={Routes.UserWallet}
            className="flex flex-col lg:flex-row"
          >
            <Flex gap="0" className="flex items-center justify-center mb-1 lg:mb-0">
              <IoWalletOutline
                className="text-[#6ca776]"
                style={{ fontSize: '1.35rem', lineHeight: '1.75rem' }}
              />
              <div className={`px-1 text-sm whitespace-nowrap ${isDesktop() ? 'text-[#6ca776] text-mid' : ''}`}>
                {t('common:labels.your-credit')}
              </div>
            </Flex>
            <Credit numColor="#6ca776" inline={isDesktop()} />
          </Link>
        }
      </div>
    </Col>
  );
};

export default Navbar;
